import React, { useState, useEffect } from 'react';

/* MUI */
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@material-ui/core';

import FormInputTypography from '../../form-input/form-input-typography.component.jsx';

const ImpermeableAreaAppeal = (props) => {
  const [data, setData] = useState({
    impermeable_area: "",
    applicant_comments: ""
  })

  const [area, setArea] = useState({
    mapBlkLot: "",
    grossTotalArea: "",
    permeableArea: "",
    impermeableArea: "",
    excludedArea: "",
  });

  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }

    if (props.area) {
      setArea(props.area);
    }
  }, [props])

  return (
    <Accordion expanded>
      <AccordionSummary id="inaccurateImperviousAreaAppeal" style={{ backgroundColor: "whitesmoke" }} >
        <Typography variant="h6" align="center" gutterBottom color="primary">
          Information for Inaccurate Impermeable Parcel Level Area
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
              <Typography variant="h6" color="error">
                There is a CURRENT APPEAL PENDING. Please contact us at ZZZ-ZZZ-ZZZZ before submitting a new request.
              </Typography>
          </Grid> */}
          <Grid item xs={4} align="center">
            <Typography variant="h6" color="textPrimary">
              {area.mapBlkLot}
            </Typography>
            <Typography variant="body2">Map Block Lot</Typography>
          </Grid>
          <Grid item xs={4} align="center">
            <Typography variant="h6" color="textPrimary">
              {data.s_Assessor_Block_Lot_No}
            </Typography>
            <Typography variant="body2">Assessor Block Lot</Typography>
          </Grid>
          <Grid item xs={4} align="center">
            <Typography variant="h6" color="textPrimary">
              {area?.grossTotalArea ? Math.round(area.grossTotalArea) : "0"}
            </Typography>
            <Typography variant="body2">Current Gross Total Area</Typography>
          </Grid>
          <Grid item xs={4} align="center">
            <Typography variant="h6" color="textPrimary">
              {area?.excludedArea ? Math.round(area.excludedArea) : "0"}
            </Typography>
            <Typography variant="body2">Current Excluded Area</Typography>
          </Grid>
          <Grid item xs={4} align="center">
            <Typography variant="h6" color="textPrimary">
              {area?.permeableArea ? Math.round(area.permeableArea) : "0"}
            </Typography>
            <Typography variant="body2">Current Permeable Area</Typography>
          </Grid>
          <Grid item xs={4} align="center">
            <Typography variant="h6" color="textPrimary">
              {area?.impermeableArea ? Math.round(area.impermeableArea) : "0"}
            </Typography>
            <Typography variant="body2">Current Impermeable Area</Typography>
          </Grid>

          <FormInputTypography
            label="Inaccurate Impermeable Area Appeal ID"
            size={6}
            value={data.customerAppealId}
          />
          <FormInputTypography
            label="Appealed Impermeable Area"
            size={6}
            value={data.impermeable_area}
          />
          <FormInputTypography
            label="Billable Appealed Impermeable Area"
            size={6}
            value={data.billable_impermeable_area}
          />
          <FormInputTypography
            label="Appealed Permeable Area"
            size={6}
            value={Math.round(data.permeable_area)}
          />
          <FormInputTypography
            label="Applicant Comments"
            size={6}
            value={data?.applicant_comments ? data?.applicant_comments : "" }
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default ImpermeableAreaAppeal;